import { useNavigate } from "react-router-dom";
import "./Content.css";

// const Blog = () => {
//   return (
//     <div className="content-container">
//       <h1>GLOBAL WEEKS OF SERVICE</h1>

//       <h2>THE ROAR FOR MENTAL HEALTH & WELLBEING</h2>

//       <p>
//         How Lions Across India United to Heal Minds and Spread Hope
//       </p>

//       <p>
//         October 4-12, 2025 | A Transformative Week That Touched Millions of Lives
//       </p>

//       <p>
//         When International President Lion A. P. Singh envisioned a series of Global Weeks of Service for India...
//       </p>

//       <p>
//         Throughout India, Lions stepped forward with empathy and purpose...
//       </p>

//       {/* 👉 Continue FULL content EXACTLY from document */}

//     </div>
//   );
// };


const Blog = () => {
      const navigate = useNavigate();
    return (
        <div
            style={{
                maxWidth: "900px",
                margin: "40px auto",
                padding: "30px",
                fontFamily: "Arial, sans-serif",
                lineHeight: "1.7",
                color: "#333",
                backgroundColor: "#fff",
                borderRadius: "10px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
        >

                   <button className="back-btn" onClick={() => navigate(-1)}>
        ← Go Back
      </button>
            <h4 style={{ textAlign: "center", color: "#777", letterSpacing: "1px" }}>
                GLOBAL WEEKS OF SERVICE
            </h4>

            <h1
                style={{
                    textAlign: "center",
                    color: "#0b3d91",
                    marginBottom: "10px",
                }}
            >
                THE ROAR FOR MENTAL HEALTH & WELLBEING
            </h1>

            <p
                style={{
                    textAlign: "center",
                    fontStyle: "italic",
                    color: "#b22222",
                    marginBottom: "20px",
                }}
            >
                How Lions Across India United to Heal Minds and Spread Hope
            </p>

            <div
                style={{
                    height: "5px",
                    width: "120px",
                    backgroundColor: "#c9a227",
                    margin: "10px auto 20px",
                    borderRadius: "5px",
                }}
            ></div>

            <p style={{ textAlign: "center", color: "#666", marginBottom: "30px" }}>
                October 4–12, 2025 | A Transformative Week That Touched Millions of Lives
            </p>

            <p>
                When International President Lion A. P. Singh envisioned a series of
                Global Weeks of Service for India, he imagined a compassionate
                awakening—one that would bring mental health and well-being to the
                forefront of community service. During October 2025, that vision came
                alive in a powerful way as Lions across the nation united for the
                transformative <strong>“Mental Health & Well-being Service Week”</strong>—
                a movement dedicated to healing minds, nurturing resilience, and
                restoring hope.
            </p>

            <p>
                Throughout India, Lions stepped forward with empathy and purpose,
                breaking the silence around mental health. Over nine impactful days,
                communities witnessed open conversations, counselling camps, awareness
                drives, school outreach programs, stress management workshops, and
                wellness initiatives that reached individuals across all age groups.
                What emerged was not just a campaign—but a national movement redefining
                care, compassion, and connection.
            </p>

            <p>
                The success of Mental Health & Well-being Service Week was driven by
                visionary leadership and a shared commitment to service. International
                President Lion A. P. Singh once again inspired the nation with his
                forward-thinking vision—encouraging Lions to address one of the most
                critical yet often overlooked aspects of human well-being.
            </p>

            <p>
                The Lions Council of India (LCOI), under the dynamic leadership of
                Chairperson PID Lion G. Babu Rao, Secretary PID Lion Pravin Chhajer,
                Treasurer PID Lion Vijaykumar Raju, and the dedicated leadership team,
                provided unwavering guidance and support. Their collective efforts
                empowered districts to take meaningful action and create lasting impact
                in their communities.
            </p>

            <p>
                Strategic direction and seamless execution were led by Service Weeks
                Coordinator LCOI—PID Lion Narendra Bhandari, whose meticulous planning
                ensured that every District could effectively implement impactful
                programs. Along with PDG Lion Abhay Shastri, Lion M. Naga Raju, and Lion
                Pinkesh Patoria, the team designed toolkits, awareness materials,
                training modules, outreach strategies, and evaluation frameworks that
                ensured consistency and excellence nationwide.
            </p>
            <p>
                Together, their efforts transformed a
                vision into a nationwide movement—one that not only raised
                awareness but also fostered acceptance, support, and well-being for countless individuals.
            </p>

            <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
                Nationwide Strategy and Planning – Suggested 9 Days Schedule
            </h3>

            <p>
                India comprises 12 Multiple Districts, 84 Districts, 8986 Clubs, and
                nearly 3 lakh Lion/Leo members. A detailed action plan was designed to
                motivate clubs nationwide. This included a 9-day suggestive programme
                guiding daily activities focused on awareness, compassion, and service.
                Each day highlighted themes like mindfulness, stress management, youth
                awareness, and emotional balance.
            </p>

            <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
                Support Material and Communication
            </h3>

            <p>
                {/* To assist every district, 23 creative designs—including banners,
        posters, and social media templates—were prepared. Presentations,
        informative PDFs, helpline numbers, and a national directory of
        organizations and experts in mental health were also shared. Materials
        were distributed via email and WhatsApp to ensure smooth communication
        with leaders across all districts. */}
                To assist every district, 23 creative designs—including banners, posters, and social media templates were prepared to promote MHW.  The
                presentations, informative PDFs, and helpline numbers, along with a national directory of government organisations,
                NGOs, and experts working in mental health were shared with all Districts. All materials were shared through emails and personal
                WhatsApp messages with GAT Area Leaders, MCCs, DGs, and GST Coordinators to ensure smooth communication.
            </p>

            <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
                Leadership Coordination and Meetings
            </h3>

            <p>
                The team conducted online meetings area-wise with GAT leaders, MCCs, DGs, and GST Coordinators.
                These sessions focused on explaining what to do, why to do it, and when to do it.
                The  district-level meetings were organized to demonstrate the execution plan and motivate lions to take active part in MHW activities.
            </p>

            <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
                Activities for All Age Groups
            </h3>

            <p>
                {/* The aim was to reach people of all age groups through diverse programs
        such as walkathons, senior citizen talks, school and college sessions,
        work-life balance programs for women, and stress-free workshops.
        Collaboration with psychologists, psychiatrists, government agencies,
        and NGOs enabled expert-led initiatives. */}
                The aim was to reach people of all age groups through diverse programmes such as walkathons, talks with senior citizens,
                sessions in schools and colleges, work-life balance programmes for working women, and stress-free service workshops for lions members.
                Collaboration with psychologists, psychiatrists, government agencies, and NGOs was encouraged for expert-led initiatives.
            </p>

            <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
                Online Events and Expert Sessions – Schedule of 12 LCIP Speakers and Topics
            </h3>

            <p>
                During MHW week, an Online Session was scheduled on Suicide Prevention with Mr. Nelson Moses, Founder of Suicide Prevention India.
                Additionally, 12 LCIP-led online sessions on diverse topics relating to mental wellbeing were presented from October 6 to 12. On the final
                day of the week on October 12, an interactive session was organized with counselling psychologist Ms. Riya Agrawal.
                A special online training was organized for preparing video, Lion Praveen Marri assisted the team.

            </p>

            {/* <p>
        A special online training for video preparation was also conducted with
        support from Lion Praveen Marri.
      </p> */}

            <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
                Team Contributions and Acknowledgements
            </h3>

            <p>
                Special recognition goes to m nagaRAJU, LCIP, for creating a pool of 100 MHW trainers in
                MD 320 and for coordinating the LCIP series of presentations; Lion Pinkesh K. Patoria, FDI,
                team member for training 36 MHW trainers, for preparing creatives/ flyers, guiding Lions in Hindi Language;
                and Lion Abhay Shastri, PDG, for preparing the booklet.
                All team members were in continuous contact with lions leaders nationwide to motivate and follow up.
            </p>

            <h3 style={{ color: "#0b3d91", marginTop: "30px" }}>
                Conclusion
            </h3>

            <p>
                With collective effort, compassion, and coordination, Lions Mental Health & Wellbeing Service Week 2025 was a historic movement.
                Participation by clubs and districts was extremely encouraging.
                Together, as one family, Lions in India raised awareness, promoted emotional wellness, and fostered a mentally healthier and happier India.
            </p>
        </div>
    );
};


export default Blog;